import Cookies from "js-cookie";

export const useHideAdsByCookie = () => {
  const noAdsPages = ["invite", "sub-user-complete", "sub-user-invite"];

  const isHideAds = () => {
    // if page is in noAdsPages, return true
    if (noAdsPages.some((page) => window.location.pathname.includes(page))) {
      return true;
    }

    const adsCookie = Cookies.get("ads");

    if (adsCookie === undefined) {
      return false; // Default behavior when cookie is not accessible
    }

    // Convert to string for consistent comparison and handle both string and number values
    const cookieValue = String(adsCookie);
    return cookieValue === "0";
  };

  return {
    isHideAds,
  };
};
